import urls from '../api_urls/newCommentKeywords'
import { _post, _upload } from '@/axios/request'
import $axios from '@/axios/config.js'
// 获取列表
export function getMatchingTableData (params) {
  return _post(urls.GET_MATCHING_LIST, params)
}
export function updateMatching (params) {
  return _post(urls.UPDATE_MATCHING, params)
}
export function getMatchingDetail (params) {
  return _post(urls.GET_MATCHING_DETAIL, params)
}
export function changeMatchingStatus (params) {
  return _post(urls.CHANGE_MATCHING_STATUS, params)
}
export function searchDliteKeyword (params) {
  return _post(urls.SEARCH_DLITE_KEYWORD, params)
}
export function getTranslationTableData (params) {
  return _post(urls.GET_TRANSLATION_LIST, params)
}
export function delTranslation (params) {
  return _post(urls.DEL_TRANSLATION, params)
}
export function addTranslation (params) {
  return _post(urls.ADD_TRANSLATION, params)
}
export function editTranslation (params) {
  return _post(urls.EDIT_TRANSLATION, params)
}
export function getTranslationDetail (params) {
  return _post(urls.GET_TRANSLATION_DETAIL, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/newCommentKeywords.js